<div class="login-main-container">
  <div class="login-side-logo" *ngIf="!isTabView">
    <img appPrependUrl src="/assets/images/transparent-home-login.png" alt="MyGooru Logo" class="logo" />
  </div>
  <div class="reset-password-container">
    <div class="login-img-container">
      <div class="illustration-container">
        <img appPrependUrl src="/assets/images/myg-mobile-profile.svg" alt="Learning Illustration" />
      </div>
      <div>
        <span class="reset-label">Reset Your Password</span>
      </div>
      <form [formGroup]="form" (ngSubmit)="resetPassword()">
        <div class="input-wrapper">
          <label for="newPassword" class="password-label">New Password</label>
          <div class="input-visibility">
            <input id="newPassword" type="password" [(ngModel)]="newPassword" [formControlName]="'newPassword'"
              name="newPassword" placeholder="Enter your new password" />
          </div>
          <div class="password-required-label"
            *ngIf="newPasswordControl?.invalid && (newPasswordControl?.dirty || newPasswordControl?.touched)">
            <span *ngIf="newPasswordControl?.errors?.['required']">
              New password is required.
            </span>
            <span
              *ngIf="newPasswordControl?.errors?.['pattern'] || newPasswordControl?.errors?.['maxlength'] || newPasswordControl?.errors?.['minlength']">
              Include uppercase, lowercase, number & symbol.
            </span>
          </div>
        </div>
        <div class="input-wrapper">
          <label for="confirmPassword" class="password-label">Confirm Password</label>
          <div class="input-visibility">
            <input id="confirmPassword" [type]="inputType" [(ngModel)]="confirmPassword"
              [formControlName]="'confirmPassword'" name="confirmPassword" placeholder="Confirm password" />
            <span class="password-toggle" (click)="togglePasswordVisibility()">
              <span class="material-icons">
                {{ inputType === "password" ? "visibility_off" : "visibility" }}
              </span>
            </span>
          </div>
          <div class="password-required-label" *ngIf="confirmPasswordControl?.dirty || confirmPasswordControl?.touched">
            <span *ngIf="form?.errors?.['passwordMismatch']">
              Passwords do not match.
            </span>
          </div>
        </div>
        <button class="submit-btn" type="submit">SUBMIT</button>
        <div class="success-alert" *ngIf="passwordUpdated">
          <div class="success-icon">
            <span class="checkmark">✓</span>
          </div>
          <div class="success-content">
            <p class="success-text">Password updated successfully.</p>
            <div class="redirect-message">
              <span>Redirecting to login page in <span class="countdown">{{ countdown }}</span> second{{ countdown > 1 ? 's' :'' }}...</span>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>